import {useTranslation} from "react-i18next";
import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/PayentMethods.module.scss";
import clsx from "clsx";
import ChevroneIcon from "@/svg/ChevronIocn.tsx";
import {useNavigate} from "react-router-dom";
import DashboardClass from "@/utils/dashboard_class.ts";


const PMethods = () => {
    const navigate = useNavigate()
    const {t} = useTranslation()

    return (
        <DashboardGenComponent
            heading={t("credit_details")}
            header_type={"dark"}
            responsive1
            column_center={
                <div className={st.column_center}>
                    <strong>{t("choose_p_method")}</strong>

                    <div className={st.method}>
                        <span>
                            {t("online_payment")}
                        </span>

                        <div className={st.method_list}>
                            <div
                                onClick={() => {
                                    navigate(DashboardClass.dashboard_routes.Banks)
                                }}
                                className={st.method_item}
                            >
                                <div className={st.left}>
                                    <div className={st.img_container}>
                                        {/*<img src={} alt="bank"/>*/}
                                    </div>

                                    Mobile Banking

                                </div>

                                <ChevroneIcon/>
                            </div>
                        </div>
                    </div>

                    <div className={st.method}>
                        <span>
                            {t("office_payment")}
                        </span>

                        <div className={st.method_list}>
                            <div onClick={() => {
                                navigate(DashboardClass.dashboard_routes.Locations)
                            }} className={st.method_item}>
                                <div className={st.left}>
                                    <div className={st.img_container}>
                                        {/*<img src={} alt="bank"/>*/}
                                    </div>

                                    {t("offices")}

                                </div>

                                <ChevroneIcon/>
                            </div>
                        </div>
                    </div>

                </div>
            }
            header_content={
                <div className={st.header_content}>
                    <span>
                        {t("payment_sum")}
                    </span>

                    <div className={st.balance}>
                        <strong
                            className={clsx(
                                st.negative,
                            )}
                        >
                            -1000 (hard)
                        </strong>
                        {t("currency")}
                    </div>
                </div>
            }

        />
    )
}

export default PMethods